import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountProfileEdit" })
export default class AccountProfileEdit extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public countries: any[] = [];
    public markets: any[] = [];
    public editData: any = null;
    public formData: any = { country: null, profileTaxType: null };
    public profileTaxTypes: any[] = [];
    public validationErrors: any[] = [];

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.getData();
    }

    public async getData() {
        this.editData = (await Axios.post(this.routes.AccountProfile_GetEditData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

        this.formData.name = this.editData.userProfile.name;
        this.formData.surname = this.editData.userProfile.surname;
        this.formData.profileTaxType = this.editData.userProfile.profileTaxType === "" ? null : this.editData.userProfile.profileTaxType;
        this.formData.country = this.editData.userProfile.country === "" ? null : this.editData.userProfile.country;
        this.formData.company = this.editData.userProfile.company;
        this.formData.location = this.editData.userProfile.location;
        this.formData.address = this.editData.userProfile.address;
        this.formData.postCode = this.editData.userProfile.postCode;
        this.formData.workingRole = this.editData.userProfile.workingRole;
        this.formData.markets = this.editData.userProfile.markets;
        this.formData.taxCode = this.editData.userProfile.taxCode;

        this.countries = this.editData.countries;
        this.markets = this.editData.markets;
        this.profileTaxTypes = this.editData.profileTaxTypes;
    }

    public setProfileTaxType() {
        if (this.formData.profileTaxType === "Company") {
            this.formData.taxCode = null;
        }

        if (this.formData.profileTaxType === "Person") {
            this.formData.company = null;
            this.formData.workingRole = null;
        }
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.AccountProfile_Edit, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

            this.isSuccess = true;

            window.location.href = this.returnUrl ? this.returnUrl : "/";
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};